export const normalizeEmail = (e: string | null | undefined): string =>
  (e ?? "").toLowerCase().trim();

export const emailEquals = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => {
  const normalized = normalizeEmail(a);

  return normalized !== "" && normalized === normalizeEmail(b);
};
